import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "36",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.3 25 5-7-5-7h2.45l5 7-5 7zm5.95 0 5-7-5-7h2.45l5 7-5 7z"
    }, null, -1)
  ])))
}
export default { render: render }